module.exports = __webpack_public_path__ + "static/assets/8ada55a2438cadea6c831f02302a959e.gif";